import classNames from 'classnames'
import { userManager } from 'helpers/authentication'
import PropTypes from 'prop-types'
import Button from 'components/shared/Button/Button'
import React from 'react'
import { translate } from 'react-i18next'

import './LogInCtaButton.scss'

const redirectToLogIn = (e) => {
  e.preventDefault()
  localStorage.setItem('authReturnUrl', window.location.href)
  userManager.signinRedirect()
}

const LogInCta = ({ t, tReady, className }) => (
  <>
    {tReady && (
      <Button
        className={classNames('c-log-in-cta__link', className)}
        data-on="click"
        data-event-action="Clicked CTA Navigation"
        type="secondary"
        text={t('project.accounts-cta.button')}
        onClick={redirectToLogIn}
      />
    )}
  </>
)

LogInCta.propTypes = {
  t: PropTypes.func.isRequired,
  tReady: PropTypes.bool.isRequired,
  className: PropTypes.string,
}

export default translate('translations')(LogInCta)
